const actions = {
  refreshB2BContacts(context, payload = {}) {
    const fallbackCompanyId = context.state?.user?.b2b?.companyId;
    const fallbackContactId = context.state?.user?.b2b?.id;
    let cachedB2b = null;
    if (typeof window !== 'undefined' && window.localStorage) {
      try {
        const cachedState = JSON.parse(window.localStorage.getItem('ossUser'));
        cachedB2b = cachedState?.user?.b2b || cachedState?.b2b || null;
      } catch (e) {
        cachedB2b = null;
      }
    }
    if (cachedB2b && !context.state?.b2b?.companyId) {
      context.commit('setB2B', cachedB2b);
    }
    const companyId =
      payload.companyId ||
      context.getters.b2bCompany?.companyId ||
      fallbackCompanyId ||
      cachedB2b?.companyId;
    const contactId =
      payload.contactId ||
      context.getters.b2bCompany?.contactId ||
      fallbackContactId ||
      cachedB2b?.id;
    const expectedContactId = payload.expectedContactId || null;
    const attempt = payload.attempt || 0;

    if (!companyId) {
      if (payload.forceUserRefresh) {
        if (attempt >= 3) {
          return Promise.resolve([]);
        }
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(
              context.dispatch('refreshB2BContacts', {
                ...payload,
                forceUserRefresh: true,
                attempt: attempt + 1
              })
            );
          }, 600);
        });
      }
      return context.dispatch('userRefresh').then(
        () =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve(
                context.dispatch('refreshB2BContacts', {
                  ...payload,
                  forceUserRefresh: true,
                  attempt
                })
              );
            }, 600);
          })
      );
    }

    if (!context.getters.userInstance?.getOtherUsers) {
      return Promise.resolve([]);
    }

    return context.getters.userInstance
      .getOtherUsers(companyId, contactId)
      .then((users) => {
        let nextUsers = users;
        if (
          expectedContactId &&
          payload.optimisticUser &&
          !users.find((user) => user.id === expectedContactId)
        ) {
          nextUsers = [...users, payload.optimisticUser];
        }
        context.commit('setB2bUserList', nextUsers);
        if (typeof window !== 'undefined' && window.localStorage) {
          try {
            window.localStorage.setItem('ossUser', JSON.stringify(context.state));
          } catch (e) {
            // Ignore localStorage failures (e.g. quota)
          }
        }
        if (payload.broadcast !== false) {
          window.dispatchEvent(
            new CustomEvent('b2b-contacts-refreshed', {
              detail: {
                source: payload.source || 'unknown',
                users: nextUsers,
                expectedContactId
              }
            })
          );
        }
        if (
          expectedContactId &&
          attempt < 8 &&
          !users.find((user) => user.id === expectedContactId)
        ) {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve(
                context.dispatch('refreshB2BContacts', {
                  companyId,
                  contactId,
                  expectedContactId,
                  optimisticUser: payload.optimisticUser,
                  attempt: attempt + 1
                })
              );
            }, 2000);
          });
        }
        return users;
      });
  },
  addsB2BContact(context, payload) {
    return new Promise((resolve, reject) => {
      context.getters.userInstance.addsB2BContact(payload, (response) => {
        if (response?.error) {
          reject(new Error(response.error));
          return;
        }
        if (response) {
          context.commit('setB2B', response.b2b);
          context
            .dispatch('userRefresh')
            .then(() => {
              setTimeout(() => {
                const expectedContactId =
                  response.registerResult?.contactId ||
                  response.data?.data?.registerB2bUser?.contactId ||
                  null;
                const userDetails = payload?.user || {};
                const fullName = [userDetails.firstName, userDetails.lastName]
                  .filter(Boolean)
                  .join(' ')
                  .trim();
                const optimisticUser = expectedContactId
                  ? {
                      id: expectedContactId,
                      name: fullName || userDetails.email || 'New contact',
                      role: 'user',
                      market:
                        response.registerResult?.market ||
                        userDetails.country ||
                        '',
                      phone: userDetails.phone || '',
                      email: userDetails.email || '',
                      address: {
                        address1: userDetails.address1 || '',
                        address2: userDetails.address2 || '',
                        city: userDetails.city || '',
                        postcode: userDetails.postcode || '',
                        province: userDetails.province || userDetails.provinceCode || '',
                        provinceCode: userDetails.provinceCode || '',
                        country: userDetails.country || ''
                      }
                    }
                  : null;
                if (optimisticUser) {
                  const currentUsers = context.getters.b2bUserList || [];
                  let nextUsers = currentUsers;
                  if (!currentUsers.find((user) => user.id === expectedContactId)) {
                    nextUsers = [...currentUsers, optimisticUser];
                    context.commit('setB2bUserList', nextUsers);
                  }
                  if (typeof window !== 'undefined') {
                    window.dispatchEvent(
                      new CustomEvent('b2b-contacts-refreshed', {
                        detail: {
                          source: 'user-area',
                          users: nextUsers,
                          expectedContactId
                        }
                      })
                    );
                  }
                }
                context.dispatch('refreshB2BContacts', {
                  expectedContactId,
                  optimisticUser
                });
              }, 750);
              resolve(response);
            });
        } else {
          reject(new Error('Response is undefined'));
        }
      });
    });
  },
  updateB2BContact(context, payload) {
    context.getters.userInstance.updateB2BContact(payload, (response) => {
      if (response) {
        context.dispatch('userRefresh').then(() => {
          context.dispatch('refreshB2BContacts');
        });
      }
    });
  },
  removeRecipientsProduct(context, payload) {
    const recipient = context.getters.recipients.find(
      (rec) => rec.lineitem?.id === payload
    );

    context.commit('removingContactItem', payload);

    if (recipient) {
      context.dispatch('checkB2bCartTotals');
      context
        .dispatch('processCarts', { market: recipient.market })
        .then(() => {});
    }
  },
  setB2bAllRecipients(context, payload) {
    context.commit('setB2bAllRecipients', payload);
  }
};

export default actions;
